// extracted by mini-css-extract-plugin
module.exports =  {"root":"flN98h7vGQOsz6rg4ALv"};